import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactPlayer from 'react-player';
import config from '../config';
import './PauseScreen.css';
import { useNavigate } from 'react-router-dom';
import { nextVideo } from '../store/PauseStore';
import { changeStoryAction, clearChapterActionsThunk, setCurrentChapter } from '../store/StoryStore';

const PauseScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const pauseState = useSelector(state => state.pauseState);
    const videos = pauseState.pauseVideos;
    const showStaticPauseVideo = pauseState.currentVideoIndex >= videos.length;
    const path = showStaticPauseVideo
        ? '/Pausebillede.mp4'
        : (config.server + videos[pauseState.currentVideoIndex].path);

    const nextVideoHandler = () => {
        dispatch(nextVideo());
    };

    const handleNavigate = () => {
        navigate('/');
    };

    return (
        <div className='video-container' onClick={handleNavigate}>
            {videos.length !== 0 ? (
                <div>
                    <div className={showStaticPauseVideo ? 'hidden text-box' : 'text-box'}>
                        Tryk på skærmen for at starte den lokale <br /> sikkerheds- og miljøinstroduktion
                    </div>
                    <ReactPlayer
                        className='video-player'
                        url = {path}
                        controls = {false}
                        playing = {true}
                        muted = {true}
                        width = "100vw"
                        height = "100vh"
                        onEnded = {nextVideoHandler}
                    />
                </div>
            ) : (
                <div className='no-video-player' onClick={handleNavigate} style={{ width: '100vw', height: '100vh' }}>
                    Ingen videoer tilgængelig
                </div>
            )}
        </div>
    );
};

export default PauseScreen;